// Module
var code = "<span class=\"product-item-sku__subitem\" system-dictionary=\"ProductFinderSKU\"> </span> <span class=\"product-item-sku__subitem\" ng-bind=\"::$ctrl.sku\"> </span>";
// Exports
module.exports = code;